import { IAccHinhThucNopTien } from "./../../../model/respone/category/IAccHinhThucNopTien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccHinhThucNopTienActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IAccHinhThucNopTien[],
  LOAD_ERRR: "",

  SAVE_START: {} as IAccHinhThucNopTien,
  SAVE_SUCCESS: {} as IAccHinhThucNopTien,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IAccHinhThucNopTien,
  CLOSE_EDIT_MODAL: undefined,
};
export const eAccHinhThucNopTienActionIds = generateActionTypeIds(
  eAccHinhThucNopTienActionsObj,
  "HINH_THUC_NOP_TIEN"
);
export type IAccHinhThucNopTienActionTypes = IGenericActionType<
  typeof eAccHinhThucNopTienActionsObj,
  "HINH_THUC_NOP_TIEN"
>;
